import React from "react";
import { Link } from "react-router-dom";

import {
  FaFingerprint,
  FaMoneyBillWave,
  FaBuilding,
  FaIdCard,
  FaBolt,
  FaArrowRight,
  FaHandshake,
  FaChartLine,
  FaCode,
} from "react-icons/fa";

const CoreServices = () => {
  // Core services data
  const services = [
    {
      id: 1,
      icon: "🪪",
      title: "NSDL PAN Card",
      description:
        "Instant PAN application & e-PAN delivery through NSDL gateway. Track status in real-time.",
      link: "/nsdl-pan-card-service",
      color: "#4f46e5", // indigo
    },
    {
      id: 2,
      icon: "🪪",
      title: "Offline PAN Card",
      description:
        "Hassle-free Offline PAN card services with document upload and digital submission.",
      link: "/offline-pan-card-service",
      color: "#10b981", // green
    },
    {
      id: 3,
      icon: "📱",
      title: "Mobile & DTH Recharge",
      description:
        "Prepaid, postpaid, and DTH recharge for all major operators with instant confirmation.",
      link: "/mobile-and-dth-recharge",
      color: "#f59e0b", // amber
    },
    {
      id: 4,
      icon: "💡",
      title: "Utility Bill Payments",
      description:
        "Pay electricity, water, gas, and broadband bills securely via BBPS platform.",
      link: "/utility-bill-payments",
      color: "#ef4444", // red
    },
    {
      id: 5,
      icon: "🚗",
      title: "Motor Insurance",
      description:
        "Two-wheeler and four-wheeler insurance policies from top insurers at competitive rates.",
      link: "/insurance-service",
      color: "#8b5cf6", // purple
    },
    {
      id: 6,
      icon: <FaCode />,
      title: "API Integration",
      description:
        "Powerful REST APIs for PAN Card, recharge, BBPS, and insurance – easy integration for businesses.",
      link: "/api-solutions",
      color: "#ec4899", // pink
    },
  ];

  return (
    <>
      {/*===== ABOUT AREA STARTS =======*/}
      <div className="about5-section-area sp1">
        <div className="container">
          <div className="row">
            <div className="col-lg-7 m-auto">
              <div className="about5-header text-center heading10">
                <h5>
                  <img src="assets/img/icons/logo-icons6.svg" alt="" />
                  Welcome to Panmitra Online Service
                </h5>
                <h2 className="text-anime-style-3">
                  India's Most Trusted PAN Card &amp; Utility Payment Platform
                </h2>
              </div>
            </div>
          </div>
          <div className="row align-items-center">
            <div className="col-lg-6">
              <img
                src="images/about-banner-2.png"
                alt="Panmitra Office"
                className="img-fluid rounded-4 shadow"
              />
            </div>
            <div className="col-lg-6">
              <div className="about5-content-area heading10">
                <h3 className="text-anime-style-3">
                  Empowering 100K+ Agents &amp; Businesses Across India
                </h3>
                <p data-aos="fade-left" data-aos-duration={1000}>
                  Panmitra Online Service Pvt. Ltd. is a trusted fintech company
                  dedicated to making essential financial services accessible to
                  everyone. From instant PAN card processing (NSDL/UTI) to
                  seamless mobile/DTH recharge, utility bill payments, motor
                  insurance (POSP), and powerful API solutions, we provide a
                  robust platform for individuals, agents, and businesses alike.
                </p>
                <div className="space32" />
                <div className="about5-boxarea">
                  <div className="row g-2">
                    <div className="col-lg-6">
                      <div className="stat-box">
                        <h3>100K+</h3>
                        <p>Active Agents</p>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="stat-box">
                        <h3>5K+</h3>
                        <p>Active Partners</p>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="stat-box">
                        <h3>5+</h3>
                        <p>Years of Excellence</p>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="stat-box">
                        <h3>24/7</h3>
                        <p>Customer Support</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="space32" />
                <div
                  className="btn-area1"
                  data-aos="fade-left"
                  data-aos-duration={1400}
                >
                  <a href="/about-us" className="header-btn11">
                    Know More About Us <i className="fa-solid fa-arrow-right" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*===== ABOUT AREA ENDS =======*/}

      {/*===== SERVICE AREA STARTS =======*/}
      <div className="service5-section-area sp1">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 m-auto">
              <div className="service-header text-center heading10">
                <h5>
                  <img src="assets/img/icons/logo-icons6.svg" alt="" />
                  Our Core Services
                </h5>
                <h2 className="text-anime-style-3">
                  Complete Suite of Digital & Financial Services
                </h2>
              </div>
            </div>
          </div>

          <div className="row g-4">
            {services.map((service, index) => (
              <div
                key={service.id}
                className="col-lg-4 col-md-6"
                data-aos="zoom-in"
                data-aos-duration={800 + index * 200}
              >
                <div className="service-card">
                  <div
                    className="service-icon-wrapper"
                    style={{
                      backgroundColor: service.color + "20",
                      color: service.color,
                    }}
                  >
                    {service.icon}
                  </div>
                  <div className="service-card-content">
                    <h3>{service.title}</h3>
                    <p>{service.description}</p>
                    <a href={service.link} className="service-card-link">
                      Learn More <FaArrowRight />
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Optional view all button (commented out) */}
        </div>
      </div>
      {/*===== SERVICE AREA ENDS =======*/}

      {/* Embedded CSS for service cards */}
      <style>{`
        .service-card {
          background: #fff;
          border-radius: 24px;
          padding: 30px 20px;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
          border: 1px solid #f0f2f5;
        }

        .service-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
          border-color: transparent;
        }

        .service-icon-wrapper {
          width: 90px;
          height: 90px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 2.8rem;
          margin-bottom: 20px;
          transition: all 0.3s ease;
        }

        .service-card:hover .service-icon-wrapper {
          background-color: ${services.map((s) => s.color)[0]} !important; /* fallback, but we'll handle via style */
          color: #fff !important;
        }

        .service-card-content h3 {
          font-size: 1.4rem;
          font-weight: 600;
          color: #1e293b;
          margin-bottom: 15px;
        }

        .service-card-content p {
          color: #4b5563;
          line-height: 1.6;
          margin-bottom: 20px;
          flex-grow: 1;
        }

        .service-card-link {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          color: #2563eb;
          font-weight: 600;
          text-decoration: none;
          transition: gap 0.3s ease;
        }

        .service-card-link:hover {
          gap: 12px;
          color: #1d4ed8;
        }

        /* Responsive adjustments */
        @media (max-width: 768px) {
          .service-card {
            padding: 20px 15px;
          }
          .service-icon-wrapper {
            width: 70px;
            height: 70px;
            font-size: 2.2rem;
          }
        }
      `}</style>
    </>
  );
};

export default CoreServices;
